export const useMenu = () => {
    const menus = [
        {
            id: "intro-group",
            title: "介紹",
            icon: "mdi-information",
            submenu: [
                {
                    id:"home",
                    title: "概觀",
                    icon: "mdi-home",
                    url: "/home"
                },
                {
                    id:"system-intro",
                    title: "系統架構",
                    icon: "mdi-sitemap",
                    url: "/system-intro"
                },{
                    id: "release-note",
                    title: "更新記錄",
                    icon: "mdi-history",
                    url: "/release-note"
                }/*
                ,{
                    id: "playground",
                    title: "遊戲區",
                    icon: "mdi-sitemap",
                    url: "/playground",
                    debug: true
                }*/
            ],
            default: {}
        },
        {
            id: "demo-group",
            title: "功能展示區",
            icon: "mdi-apps",
            submenu: [
                {
                    id:"dashboard",
                    title: "儀表板",
                    icon: "mdi-monitor-dashboard",
                    url: "/dashboard"
                },
                {
                    id: "sales",
                    title: "業務員業績",
                    icon: "mdi-database",
                    url: "/sales"
                }
            ],
            default: {}
        }
    ]
    return menus
}
